/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import type {
  ApiKeyResponse,
  ApiKeysResponse,
  CreateApiKeyRequest,
  DeleteUsersApiKeysRequest,
} from '@modules/cloud-api/v1/types'
import type { DeleteApiKeyUrlParams } from '@modules/cloud-api/v1/urls'
import {
  createApiKeyUrl,
  deleteApiKeyUrl,
  deleteUsersApiKeysUrl,
  getApiKeysUrl,
  getUsersApiKeysUrl,
} from '@modules/cloud-api/v1/urls'
import { fetchAsJson } from '@modules/query/helpers'

export const getCurrentUserApiKeys = (nextPage?: string): Promise<ApiKeysResponse> =>
  fetchAsJson<ApiKeysResponse>(getApiKeysUrl({ nextPage }), {
    method: 'get',
  })

export const getAllUsersApiKeys = (): Promise<ApiKeysResponse> =>
  fetchAsJson<ApiKeysResponse>(getUsersApiKeysUrl(), {
    method: 'get',
  })

export const createApiKey = (payload: CreateApiKeyRequest): Promise<ApiKeyResponse> =>
  fetchAsJson<ApiKeyResponse>(createApiKeyUrl(), {
    method: 'post',
    body: JSON.stringify(payload),
  })

export const deleteCurrentUserApiKey = (payload: DeleteApiKeyUrlParams): Promise<void> =>
  fetchAsJson<void>(deleteApiKeyUrl(payload), {
    method: 'delete',
  })

export const deleteUsersApiKeys = (payload: DeleteUsersApiKeysRequest): Promise<void> =>
  fetchAsJson<void>(deleteUsersApiKeysUrl(), {
    method: 'delete',
    body: JSON.stringify(payload),
  })
